import type { MandeInstance } from 'mande';
import type { MediaLogger } from './types';

export const mediaMandeSymbol = Symbol( 'media-mande' );
export const onVideoPlaySymbol = Symbol( 'on-video-play' );
export const mediaLoggerSymbol = Symbol( 'media-logger' );

export type MediaMandeProvider = MandeInstance;
export type OnVideoPlayProvider = ( videoId: string ) => void;
export type MediaLoggerProvider = MediaLogger;
